import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { InventoryManagerListItem } from "../../inventory.types";
import { requestCreateInventoryManager } from "./createInventoryManager.request";

const useCreateInventoryManager = (
  options?: MutationOptions<InventoryManagerListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateInventoryManager,
    onError: toastServerError,
    ...options
  });
};

export default useCreateInventoryManager;
